export default __webpack_public_path__ + "static/media/robot_1.efd11420.png";